import http from 'plugins/axios';

export default {
  approveAudit(data) {
    return http.post({
      url: '/la/admin/c2c/audit',
      data,
      dataType: 'form'
    });
  },
  rejectAudit(data) {
    return http.post({
      url: '/la/admin/c2c/reject',
      data,
      dataType: 'form'
    });
  },
  getAllList(data) {
    return http.get({
      url: '/la/admin/c2c/order/all',
      data
    });
  },
  cancelOrder(data) {
    return http.post({
      url: '/la/admin/c2c/order/cancel',
      data,
      dataType: 'form'
    });
  },
  gaveMoney(data) {
    return http.post({
      url: '/la/admin/c2c/order/all/pay',
      data,
      dataType: 'form'
    });
  },
  receivedMoney(data) {
    return http.post({
      url: '/la/admin/c2c/order/coinRelease',
      data,
      dataType: 'form'
    });
  }
};
